import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'
import { lighten } from 'utils/styles'

const { unit, half } = measures

export const container = css`
  display: flex;
  align-items: center;
`

export const paginationContainer = css`
  border: 1px solid ${colors.white40};
  border-radius: 30px;

  display: flex;
  flex-direction: row;

  overflow: hidden;
`

export const paginatorItem = css`
  background-color: ${colors.blues.blue1};

  cursor: pointer;
  color: ${colors.white40};

  display: flex;
  align-items: center;

  :hover {
    background-color: ${lighten(colors.white40, 10)};
    color: ${colors.white40};
  }
`

export const paginatorItemDisabled = css`
  cursor: not-allowed;
  background-color: ${colors.grays.gray2};

  :hover {
    color: ${colors.black100};
    background-color: ${colors.grays.gray3};
  }
`

export const paginatorActivePage = css`
  background-color: ${colors.greens.green6};
  color: ${colors.greens.green6};

  & > a {
    color: ${colors.greens.green6};
  }
`

export const paginatorLink = css`
  color: ${colors.white100};
  background: ${colors.blues.blue1};
  display: block;
  cursor: pointer;
  outline: none;
  padding: ${unit}px ${2 * half}px;
`
